<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, required: true },
  actionLabel: { type: String, default: '' },
});

const emit = defineEmits(['click']);
</script>

<template>
  <div class="flex flex-col items-center gap-8">
    <section class="w-full px-6 py-5 custom-dashed-border rounded-2xl">
      <p class="mb-0 text-sm text-n-slate-12">{{ subtitle }}</p>
    </section>
    <div class="flex flex-col items-center gap-6">
      <h2 class="text-3xl font-medium text-center text-n-slate-12">
        {{ title }}
      </h2>
      <Button
        v-if="actionLabel"
        :label="actionLabel"
        icon="i-lucide-plus"
        @click="emit('click')"
      />
    </div>
  </div>
</template>
